export default "__VITE_ASSET__DIRGhhXy__"